module.exports = __webpack_public_path__ + "static/portfolio-mas-16-7929cb6c764701d20e60a180b1a868c8.jpg";